(function() {
  'use strict';

  function EmailTypeComponentController(
    Router,
    $scope,
    $rootScope,
    $translate,
    EmailTypes,
    EmailType,
    DEFAULT_TEMPLATE_ID,
    Security,
    Notify,
    Utils
  ) {
    var ctrl = this;

    var load = function() {
      ctrl.loadType()
        .then(function() {
          ctrl.loadActions();
        });
    };

    ctrl.$onInit = function() {
      load();
    };

    ctrl.loadType = function() {
      return EmailTypes.find(ctrl.emailTypeId)
        .then(function(emailType) {
          ctrl.emailType = new EmailType(emailType);
          Utils.setPageTitle('Edit email type: ' + ctrl.emailType.doc.name);
        });
    };

    $scope.$on('EmailTypeChanged', function() {
      load();
    });

    ctrl.reload = function() {
      $rootScope.$broadcast('EmailTypeChanged');
    };

    ctrl.isDefault = function() {
      return ctrl.emailType.doc.defaultTemplate.id === DEFAULT_TEMPLATE_ID;
    };

    ctrl.loadActions = function() {
      // These are the currently viewed email template actions
      // They relate only to the current email template
      ctrl.emailTemplateActions = [
        // {
        //   label: $translate.instant('Send test email'),
        //   onClick: function() {
        //     EmailTypes.sendTestEmail(ctrl.emailType.doc.id,
        //     ctrl.emailType.doc.defaultTemplate.id)
        //       .then(function() {
        //         Notify.success('A test email has been sent to your email address');
        //       })
        //       .catch(function(err) {
        //         var msg = 'Unknown error';
        //         if (err && err.message) {
        //           msg = err.message;
        //         }
        //         Notify.error(msg);
        //       });
        //   },
        //   showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
        //   klass: 'btn-info btn-sm'
        // }
      ];

      // These are the email type actions that affect all the templates
      ctrl.emailTypeActions = [
        {
          label: $translate.instant('Edit'),
          onClick: function() {
            var templateId = ctrl.isDefault() ? 'new' : ctrl.emailType.doc.defaultTemplate.id;
            Router.navigate(['/emails', ctrl.emailTypeId, templateId]);
          },
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.edit'),
          klass: 'btn-primary'
        },
        // {
        //   label: $translate.instant('Disable'),
        //   type: 'link',
        //   color: 'warning',
        //   position: 1,
        //   onClick: function() {
        //     return EmailTypes.disable(ctrl.emailType.doc.id)
        //       .then(function() {
        //         Notify.success('Template has been disabled');
        //         return ctrl.reload();
        //       })
        //       .catch(Notify.error);
        //   },
        //   showCondition: function() {
        //     if (ctrl.emailType.isDisabled()) {
        //       return false;
        //     }
        //     return Security.hasPermission('emailTemplates.edit');
        //   },
        //   klass: 'text-warning'
        // },
        {
          label: $translate.instant('Send test email'),
          onClick: function() {
            EmailTypes.sendTestEmail(ctrl.emailType.doc.id, ctrl.emailType.doc.defaultTemplate.id)
              .then(function() {
                Notify.success('A test email has been sent to your email address');
              })
              .catch(function(err) {
                var msg = 'Unknown error';
                if (err && err.message) {
                  msg = err.message;
                }
                Notify.error(msg);
              });
          },
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
          klass: 'text-info',
          color: 'info',
          type: 'link',
          position: 1
        },
        {
          label: $translate.instant('View sent emails'),
          color: 'info',
          type: 'link',
          position: 1,
          onClick: function() {
            Router.navigate(['/emails', ctrl.emailTypeId, 'log']);
          },
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.view')
        }
      ];
    };
  }

  EmailTypeComponentController.$inject = [
    'Router',
    '$scope',
    '$rootScope',
    '$translate',
    'EmailTypesService',
    'EmailTypeFactory',
    'DEFAULT_TEMPLATE_ID',
    'SecurityService',
    'NotifyService',
    'UtilsService'


  ];

  angular.module('component.emailTemplates')
    .component('emailTypeComponent', {
      templateUrl: 'app/components/email-templates/email-type.html',
      controller: EmailTypeComponentController,
      bindings: {
        emailTypeId: '<'
      }
    });
})();
